import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './styling/Navbar.css';
import logoimg from './styling/images/logo.png';

const Navbar = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { 
    // Close the dropdown and mobile menu when the location changes
    setDropdownOpen(false);
    setMobileMenuOpen(false); 
  }, [location]);

  const handleDropdownToggle = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleScroll = () => { 
    const navbar = document.querySelector('.navbar');
    const scrolled = window.scrollY > 0;
    navbar.classList.toggle('scrolled', scrolled);
  };

  useEffect(() => {
    // Add scroll event listener for sticky behavior
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav className={`navbar ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
      <NavLink to="/" className={`logo ${isMobileMenuOpen ? 'center' : ''}`}>
        <img src={logoimg} alt="Logo" />
      </NavLink>

      <div className= {`burger-menu  ${isMobileMenuOpen ? 'animate' : ''}`} onClick={handleMobileMenuToggle}>
        <div className={`bar ${isMobileMenuOpen ? 'animate' : ''}`}></div>
        <div className={`bar ${isMobileMenuOpen ? 'animate' : ''}`}></div>
        <div className={`bar ${isMobileMenuOpen ? 'animate' : ''}`}></div>
      </div>

      <div className={`nav-links ${isMobileMenuOpen ? 'show' : ''}`}>
        <NavLink to="/" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
          Home
        </NavLink>
        <div
          className={`nav-link dropdown toggle ${isMobileMenuOpen ? 'mobile-toggle' : ''}`}
          onMouseEnter={handleDropdownToggle} 
          onMouseLeave={handleDropdownToggle}
          onClick={handleDropdownToggle}
        >
          <NavLink to="/products"  className={({ isActive }) => `nav-link ${isActive ? 'active' : 'dropdown-link'}`}>
            Products <span>+</span> 
          </NavLink>
          {isDropdownOpen && (
            <div className={`dropdown-content ${isDropdownOpen ? 'show' : ''}`}>
              <NavLink
                to="/product_items/Ups"
                className={({ isActive }) => `dropdown-link ${isActive ? 'active' : ''}`}
              >
                UPS
              </NavLink>
              <NavLink
                to="/product_items/Stabilizer"
                className={({ isActive }) => `dropdown-link ${isActive ? 'active' : ''}`}
              >
                Stabilizer
              </NavLink>
              <NavLink
                to="/product_items/LineConditioner"
                className={({ isActive }) => `dropdown-link ${isActive ? 'active' : ''}`}
              >
                Line Conditioner
              </NavLink>
              <NavLink
                to="/product_items/Solar"
                className={({ isActive }) => `dropdown-link ${isActive ? 'active' : ''}`}
              >
                Solar
              </NavLink>
              <NavLink
                to="/product_items/ManualRegulator"
                className={({ isActive }) => `dropdown-link ${isActive ? 'active' : ''}`}
              > 
                Manual Regulator
              </NavLink>
              <NavLink
                to="/product_items/Battery"
                className={({ isActive }) => `dropdown-link ${isActive ? 'active' : ''}`}
              >
                Battery
              </NavLink>
              <NavLink
                to="/product_items/Transformer"
                className={({ isActive }) => `dropdown-link ${isActive ? 'active' : ''}`}
              >
                Transformer
              </NavLink>
            </div>
          )}
        </div>
        <NavLink to="/profile" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
          Profile
        </NavLink>
        <NavLink
          to="/certifications" 
          className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
        >
          Certifications
        </NavLink>
        <NavLink to="/dealerships" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
          Dealerships
        </NavLink>
        <NavLink to="/repairingandservicecontracts" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
          Repairing & Service Contracts
        </NavLink>
        <NavLink to="/clientlist" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
          Client List
        </NavLink>
        <NavLink to="/contact" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
          Contact
        </NavLink>
      </div>
    </nav>
  );
};

export default Navbar;